import React from "react";
import Navbar from "../components/Navbar";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import thankimg from "../assets/icons/thank.png";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import thanks from "../assets/thankyou-json.json";
import Lottie from 'lottie-react';


const ThankYou = () => {
  return (
    <>
      <Helmet>
        <title>TimeWatch Infocom</title>
        <meta
          name="description"
          content="Thank you for choosing TimeWatch Infocom! We appreciate your trust in our advanced biometric solutions, access control systems, and smart security technologies. Your interest in our time attendance systems, entrance automation, and parking management solutions means a lot to us. We are committed to providing reliable, innovative security solutions tailored to your needs. Stay tuned for updates and support as we continue to offer the best in security technology. For inquiries or assistance, feel free to contact our team, and we look forward to serving you."
        />
        <link rel="canonical" href="https://www.timewatchindia.com/thank-you" />
      </Helmet>
      <div
        className="thankyou-page"
        style={{ textAlign: "center", padding: "50px" }}
      >
        <Navbar />
        {/* <img  src={thankimg} style={{ margin: 'auto'}}/> */}
        <div className="lottie-container">
          {/* <DotLottieReact autoplay loop src="/lottie/thanks.lottie" /> */}
          <Lottie animationData={thanks} loop={true} autoplay={true} />
        </div>
        <h1
          className="fw-bold"
          style={{
            textAlign: "center",
            justifyContent: "center",
            color: "#282C3C",
          }}
        >
          For Your Enquiry!
        </h1>
        <p
          style={{
            marginTop: "2rem",
            textAlign: "center",
            justifyContent: "center",
            color: "#FF8181",
          }}
        >
          Your submission has been recorded.
        </p>
        <p
          style={{
            textAlign: "center",
            justifyContent: "center",
            color: "#FF8181",
          }}
        >
          Our executives will get in touch with you shortly.
        </p>
        <Link to="/">
          <button
            className="py-2 mt-4 fs-5 fw-bold explore-button"
            style={{
              // backgroundColor: "white",
              color: "#f14144",
              border: "2px solid #f14144",
              borderRadius: "40px",
              paddingInline: "40px",
            }}
          >
            Explore More!
          </button>
        </Link>
      </div>
    </>
  );
};

export default ThankYou;
